import { Injectable } from '@angular/core';

@Injectable({
 providedIn: 'root'
})

export abstract class AbstractAnalyticsService {

 constructor() { }
 abstract identify(userId?: string): void;
 abstract logout(): void
 abstract sendClaroEvent(eventName: string, eventValue?: Object, userIdOverride?:string, orgIdOverride?:string, mailAddressOverride?: string): void;
 abstract makeMoovEvent(counterpartId: string, moovId: string, issueId: string, activeMoodId: string): void;
 abstract issueSelectedEvent(counterpartId: string, issueId: string): void;
 abstract moovViewedEvent(counterpartId: string, issueId: string, moovId: string): void;
 abstract showMoreMoovsSelected(counterpartId: string, issueId: string): void;
 abstract challengeFlowClickEvent(counterpartId: string): void;
 abstract teamMemberReviewed(counterpartId: string): void;
 abstract teamMemberReviewedFromExternalLink(counterpartId: string) :void;
 abstract teamMemberInsightsReviewed(counterpartId: string): void;
 abstract activeMoovEndedEvent(counterpartId: string, issueId: string, moovId: string, activeMoodId: string): void;
 abstract activeMoovViewedEvent(counterpartId: string, issueId: string, moovId: string, activeMoodId: string): void;
 abstract activeMoovExtendedEvent(counterpartId: string, issueId: string, moovId: string, activeMoodId: string): void;
 abstract recommendedMoovReviewed(counterpartId: string, moovId: string): void;
 abstract userEngagementUnsubscribeEvent(): void;
 abstract loginEvent(): void;
 abstract activeMoovStepCheckedEvent(): void;
 abstract activeMoovStepCommentSavedEvent(): void;
 abstract tokenLoginEvent(): void;
 abstract discoveryProcessStartedEvent(): void;
 abstract discoveryProcessResumedEvent(): void;
 abstract discoveryProcessCompletedEvent(): void;
 abstract teamMemberMoovsTabSelected(counterpartId: string): void;
 abstract teamMemberInsightsTabSelected(counterpartId: string): void;
 abstract moovFeedback(moovId: string, activeMoovId: string, moovRating: number, counterpartId: string): void;
 abstract userRespondedToQuestioner(): void;
 abstract userRespondedAgainToDriverGapQuestion(userId:string, orgId:string, mailAddress: string): void;
 abstract UserFailedToResponsedToQuestioner(): void;
 abstract UserMutedQuestionVideo(): void;
 abstract UserUnMutedQuestionVideo(): void;
 abstract UserMutedIntroVideo(): void;
 abstract UserUnMutedIntroVideo(): void;
 abstract teamViewPage(): void;
 abstract teamMemberDetailsViewPage(): void;
 abstract myMotivationsPage(): void;
 abstract specficMotivationPage(driverId: string): void;
 abstract userEndedQuestioner(): void;
 abstract userStartedRediscovery(): void;
 abstract userEndedRediscovery(): void;
 abstract userHitMoreInfoOnTips(): void;
 abstract userUnsubscribedEvent(type:number): void;
 abstract userRespondedToDriverGapQuestion(userId:string, orgId:string, mailAddress: string): void;
 abstract userSelfRegistered(): void;
}